import React from 'react'
import {Flex} from '/app/src/component'
import SVG from 'react-inlinesvg'
import Theme from '/app/src/theme';

const textStyle = {
    fontSize: '14px',
    fontWeight: '500',
    vAlignContent:'center'
}

const FeatureItem = ({imgSrc, featureName, color}) => {
    const container = {
        color: color,
        marginRight: '30px'
    }
    const iconStyle = {
        height: '30px',
        width: '30px',
        fill: Theme.colors[color]
    }
    return (
        <Flex {...container}>
            <Flex {...iconStyle } center>
                <SVG src={imgSrc} style={iconStyle} />
            </Flex>
            <Flex {...textStyle}>
                {featureName}
            </Flex>
        </Flex>
    )
}

export default FeatureItem



// WEBPACK FOOTER //
// ./src/component/Modal/WelcomeModal/FeatureItem.js